import { signIn, signOut } from '@/services/authService'

const TOKEN_KEY = 'token'
const USER_KEY = 'user'
const COMPANY_ID_KEY = 'companyId'
const COMPANY_CODE_KEY = 'companyCode'

function loadStoredUser() {
  try {
    const raw = localStorage.getItem(USER_KEY)
    return raw ? JSON.parse(raw) : null
  } catch {
    return null
  }
}

const state = {
  token: localStorage.getItem(TOKEN_KEY) || null,
  user: loadStoredUser(),
  companyId: localStorage.getItem(COMPANY_ID_KEY) || null,
  companyCode: localStorage.getItem(COMPANY_CODE_KEY) || null,
}

const getters = {
  isAuthenticated: (state) => !!state.token,
  currentUser: (state) => state.user,
  companyId: (state) => state.companyId,
  companyCode: (state) => state.companyCode,
}

const mutations = {
  SET_AUTH(state, { token, user, companyId, companyCode }) {
    state.token = token
    state.user = user
    state.companyId = companyId
    state.companyCode = companyCode
    localStorage.setItem(TOKEN_KEY, token)
    localStorage.setItem(USER_KEY, JSON.stringify(user))
    localStorage.setItem(COMPANY_ID_KEY, String(companyId))
    localStorage.setItem(COMPANY_CODE_KEY, companyCode)
  },
  CLEAR_AUTH(state) {
    state.token = null
    state.user = null
    state.companyId = null
    state.companyCode = null
    localStorage.removeItem(TOKEN_KEY)
    localStorage.removeItem(USER_KEY)
    localStorage.removeItem(COMPANY_ID_KEY)
    localStorage.removeItem(COMPANY_CODE_KEY)
  },
}

const actions = {
  async login({ commit }, { companyCode, login, password }) {
    const data = await signIn(companyCode, login, password)
    commit('SET_AUTH', {
      token: data.token,
      user: data.user,
      companyId: data.companyId,
      companyCode: data.companyCode,
    })
    return data
  },

  async logout({ commit, state }) {
    if (state.token) {
      try {
        await signOut()
      } catch {
        // Clear local session even if sign-out request fails.
      }
    }
    commit('CLEAR_AUTH')
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
